import { useState } from "react";

import type { SelectedAccount } from "../banking-accounts/utils";

export const useBankingAccountsModals = () => {
  const [isConnectModalOpen, setIsConnectModalOpen] = useState(false);
  const [isRequirementsModalOpen, setIsRequirementsModalOpen] = useState(false);
  const [isFloatingFilesListOpen, setIsFloatingFilesListOpen] = useState(false);
  const [isAccountDetailsPanelOpen, setIsAccountDetailsPanelOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState<SelectedAccount | null>(null);

  const onSelectAccount = (account: SelectedAccount) => {
    setSelectedAccount(account);
    setIsAccountDetailsPanelOpen(true);
  };

  return {
    isConnectModalOpen,
    setIsConnectModalOpen,
    isRequirementsModalOpen,
    setIsRequirementsModalOpen,
    isFloatingFilesListOpen,
    setIsFloatingFilesListOpen,
    isAccountDetailsPanelOpen,
    setIsAccountDetailsPanelOpen,
    selectedAccount,
    onSelectAccount,
  };
};
